import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { getInviteesFromExpApi, getUsersFromCollaborationGraph } from '@atlassian/invite-prompt';
import type { Invitees } from '@atlassian/invite-prompt';

import { useSessionData } from '@confluence/session-data';

export const useGetInviteesFromExpApi = () => {
	const { cloudId: confluenceCloudId, userId } = useSessionData();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		async (pageId: string, jiraCloudId: string): Promise<Invitees> => {
			if (!userId) {
				return [];
			}

			const collaborators = await getUsersFromCollaborationGraph(confluenceCloudId, userId);

			if (!collaborators || collaborators.length === 0) {
				return [];
			}

			const accountIds = collaborators.map((c) => c.id);

			const response = await getInviteesFromExpApi(
				jiraCloudId,
				confluenceCloudId,
				pageId,
				userId,
				accountIds,
			);

			if (response.ineligibilityReason === undefined || response.ineligibilityReason === null) {
				createAnalyticsEvent({
					type: 'sendOperationalEvent',
					data: {
						action: 'succeeded',
						actionSubject: 'getInvitees',
						actionSubjectId: 'invitePromptFlag',
						source: 'inviteOnLinkInsert',
						attributes: {
							jiraCloudId,
							confluenceCloudId,
							invitees: accountIds,
							numberOfInvitees: accountIds.length,
						},
					},
				}).fire();

				return collaborators.filter((c) => response.accountIds.includes(c.id));
			} else {
				return [];
			}
		},
		[confluenceCloudId, createAnalyticsEvent, userId],
	);
};
